query allMarketDisplayConfigurations {
  allMarketDisplayConfigurations(
    orderBy: POSITION_ASC,
  ) {
    nodes {
      defaultName,
      marketCode
      shortNamePattern
      longNamePattern
      selections
      parameters
      sportId
      operatorId
    }
  }
}
